var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMoreOptionsWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 11.7852C15.1454 11.7852 14.25 10.8897 14.25 9.78516C14.25 8.68059 15.1454 7.78516 16.25 7.78516C17.3546 7.78516 18.25 8.68059 18.25 9.78516C18.25 10.8897 17.3546 11.7852 16.25 11.7852ZM16.25 18.0002C15.1454 18.0002 14.25 17.1047 14.25 16.0002C14.25 14.8956 15.1454 14.0002 16.25 14.0002C17.3546 14.0002 18.25 14.8956 18.25 16.0002C18.25 17.1047 17.3546 18.0002 16.25 18.0002ZM14.25 22.2152C14.25 23.3197 15.1454 24.2152 16.25 24.2152C17.3546 24.2152 18.25 23.3197 18.25 22.2152C18.25 21.1106 17.3546 20.2152 16.25 20.2152C15.1454 20.2152 14.25 21.1106 14.25 22.2152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMoreOptionsWeb);
export default __webpack_public_path__ + "static/media/ico_more_options_web.daec8fe06b2c8ff0417cc746cb9df5c3.svg";
export { ForwardRef as ReactComponent };